/**
 * Product Image Loader
 *
 * Marks native product primary images with data-rimg="loaded" once the browser
 * finishes fetching them, so the CSS skeleton animation stops and the image
 * fades in.
 */
(function () {
  'use strict';

  var SELECTOR = '.productitem--image img.productitem--image-primary[data-rimg=""]';

  function getProductImages(root) {
    var scope = root || document;
    var imgs = [];

    if (scope.matches && scope.matches(SELECTOR)) {
      imgs.push(scope);
    }

    if (scope.querySelectorAll) {
      imgs = imgs.concat(Array.prototype.slice.call(scope.querySelectorAll(SELECTOR)));
    }

    return imgs;
  }

  function markEagerProductImages(root) {
    var scope = root || document;
    var imgs = getProductImages(scope);

    for (var i = 0; i < imgs.length; i++) {
      (function (img) {
        if (img.complete && img.naturalWidth > 0) {
          img.setAttribute('data-rimg', 'loaded');
        } else if (!img.__mmProductImageLoaderBound) {
          img.__mmProductImageLoaderBound = true;
          img.addEventListener('load', function () {
            img.setAttribute('data-rimg', 'loaded');
          });
          img.addEventListener('error', function () {
            // Gracefully clear the skeleton even when the image 404s
            img.setAttribute('data-rimg', 'error');
          });
        }
      })(imgs[i]);
    }
  }

  // Initial run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      markEagerProductImages();
    });
  } else {
    markEagerProductImages();
  }

  // Re-run after Shopify section injection (theme editor, live preview)
  document.addEventListener('shopify:section:load', function (event) {
    markEagerProductImages(event.target);
  });

  // Re-run when rimg begins watching a new container (AJAX collections, etc.)
  document.addEventListener('theme:rimg:watch', function (event) {
    setTimeout(function () {
      markEagerProductImages(event.target);
    }, 0);
  });

  // Re-run when product cards are injected after page load (recently viewed,
  // recommendations, wishlist refreshes, etc.).
  document.addEventListener('mm:cards:added', function (event) {
    setTimeout(function () {
      markEagerProductImages((event && event.target) || document);
    }, 0);
  });

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        for (var i = 0; i < mutation.addedNodes.length; i++) {
          var node = mutation.addedNodes[i];
          if (node.nodeType === 1) {
            markEagerProductImages(node);
          }
        }
      });
    });

    function observeInjectedProductCards() {
      if (!document.body) return;
      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeInjectedProductCards, { once: true });
    } else {
      observeInjectedProductCards();
    }
  }
})();
